import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import { TaskProvider, useTasks } from './context/TaskContext';
import LoginPage from "./pages/LoginPage";
import SignupPage from "./pages/SignupPage";
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import AnalyticsPage from './pages/AnalyticsPage';
import CalendarPage from './pages/CalendarPage';
import SettingsPage from './pages/SettingsPage';
import './styles/globals.css';

const AppShell = () => {
  const { dark } = useTasks();
  const location = useLocation();

  // Hide sidebar on login & signup pages
  const hideSidebar =
    location.pathname === "/" ||
    location.pathname === "/signup";

  return (
    <div className={dark ? "dark" : "light"}>
      <div className="flex h-screen bg-gray-50 dark:bg-[#0f1117] overflow-hidden">

        {/* Show Sidebar only after login */}
        {!hideSidebar && <Sidebar />}
        <main className="flex-1 overflow-hidden">
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/analytics" element={<AnalyticsPage />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/settings" element={<SettingsPage />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

const App = () => (
  <BrowserRouter>
    <TaskProvider>
      <AppShell />
    </TaskProvider>
  </BrowserRouter>
);

export default App;
